const preferences = {
  preferenceSettings: {
    nameAlreadyExist: 'Nome ripetuto!',
    nameIsEmpty: 'Il nome è vuoto!',
    notificationPreference:
      'Selezionare i siti e le corrispondenti impostazioni delle preferenze relative alle notifiche',
    option1: 'Voglio ricevere le notifiche raccomandate da Enphase per tutti i siti',
    option2: 'Voglio personalizzare le mie notifiche',
    pageHeader: 'Preferenze',
    title: "Seleziona un'opzione per le notifiche",
    saveDialogHeader: 'Salvare le modifiche?',
    saveConfirmText: 'Si desidera salvare le modifiche apportate?',
    cancelButton: 'Scarta',
    saveButton: 'Salva',
    defaultDeselectWarning: 'Nota: Non è possibile rimuovere i siti dal Set di preferenze predefinite',
    displayPreferences: 'Visualizza preferenze',
    ownSites: 'Siti personali',
    otherSites: 'Altri siti',
    emptySites: 'Nessun sito disponibile!',
    emptyPreferenceSet: 'Nessuna preferenza!',
    preference: 'Preferenza',
    actions: 'Azioni',
    settingsInfo: 'Queste applicazioni sono valide solo per i siti Ensemble',
    selectType: 'Set di preferenze',
    selectSite: 'Selezione sito',
    selectSettings: 'Impostazioni delle preferenze relative alle notifiche',
    addText: 'Inserisci',
    deleteAlertHeader: 'Conferma eliminazione',
    deleteAlertDescription: 'Rimuovere in modo permanente questa preferenza?',
    deleteAlertCancel: 'Annulla',
    deleteAlertConfirm: 'Ok',
    siteEditWarning:
      'Per impostazione predefinita, tutti i siti di proprietà e gli altri siti sono impostati, rispettivamente, su "Preferenza predefinita - di proprietà" e su "Preferenza predefinita - Altri" come Preferenza di notifica.',
    defaultOwnInfo: 'Tutti i siti di proprietà sono impostati su "Preferenza predefinita - di proprietà"',
    defaultOtherInfo: 'Tutti gli altri siti sono impostati su "Preferenza predefinita - Altri"',
    defaultInfo: 'Tutti i siti sono impostati su "Preferenza predefinita"',
    createNew: 'Aggiungi nuova preferenza',
    siteEditWarningMinimal:
      'Per impostazione predefinita, i siti sono impostati su "Preferenza predefinita" come preferenza di notifica',
    selectAll: 'Seleziona tutto',
    generalNotification: 'Notifiche generali',
    switchToNewPreferencePage: 'PASSA ALLA VECCHIA PAGINA PREFERENZE'
  },
  preferences: {
    pageHeader: 'Preferenze',
    title: 'Impostazioni delle preferenze',
    notificationPreference: 'Preferenze riguardo alle notifiche',
    activationNotification: 'Inviami notifiche di attivazione.',
    monthlySummary: 'Inviami i riepiloghi mensili sulle prestazioni del sistema.',
    newsletters: 'Inviami newsletter, promozioni e sondaggi riguardo a prodotti o servizi Enphase.',
    newLeadsNotification: 'Avvisami di nuovi lead e del loro cambio di stato',
    alertEmail: 'PREFERENZE PER LE E-MAIL SUGLI AVVISI',
    deviceEventsEmail:
      'Avvisami tramite e-mail di eventi a livello di dispositivo (seleziona di seguito il livello di impatto):',
    exceptionsAlertEmail: 'Puoi specificare delle eccezioni alle preferenze e-mail sugli avvisi in base al sistema.',
    alertPreferences: 'Visualizza preferenze avvisi per sistema',
    saveNotificationPreferences: 'SALVA PREFERENZE NOTIFICHE',
    displayPreferences: 'Visualizza preferenze',
    displayUnits: 'Visualizza unità',
    metric: 'Metrica',
    imperial: 'Imperiale',
    saveDisplayPreferences: 'SALVA PREFERENZE DI VISUALIZZAZIONE',
    systemAlert: 'Preferenze sugli avvisi di sistema: ',
    saveChanges: 'Salva modifiche',
    label: 'Avvisami tramite e-mail di eventi a livello di dispositivo (seleziona di seguito il livello di impatto):',
    alertEmailPreference: 'Preferenza per le e-mail sugli avvisi',
    systems: 'Sistemi'
  }
};

export default preferences;
